<!-- @veltra/icons generated sha256:74d9cb6c1f3ee4b8 gen:8 source:src/svg/normal/more-vertical.svg -->
<script setup lang="ts">
defineOptions({ name: 'MoreVertical' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M9 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0M8 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    />
  </svg>
</template>
